module.exports = __webpack_public_path__ + "teqbahn-assets/media/41.04ac2215.png";